import { composeIO } from 'react-compose-io'
import { fieldsAcaoTransformacaoApiIO } from './FieldsAcaoTransformacaoApi.IO'
import { FieldsAcaoTransformacaoApiView } from './FieldsAcaoTransformacaoApi.View'

export const FieldsAcaoTransformacaoApi = composeIO(FieldsAcaoTransformacaoApiView, fieldsAcaoTransformacaoApiIO)
